export enum ScheduleType {
  OEM = 1,
  Custom = 2,
}